import CurriculaService from "@/services/CurriculaService";
import { getListItems, getListPagination } from "@/utils/listHelpers";
import { getApiErrorMessage, notifyStoreError } from "@/utils/storeHelpers";

export default {
    namespaced: true,
    state: {
        curriculaData: [],
        curriculum: [],
        newCurriculum: [],
        status: null,
    },
    getters: {
        getCurriculaData: (state) => getListItems(state.curriculaData),
        getCurriculaPagination: (state) => getListPagination(state.curriculaData),
        getCurriculumData: (state) => state.curriculum,
        getNewCurriculumData: (state) => state.newCurriculum,
        getStatus: (state) => state.status,
    },
    mutations: {
        setCurriculaData(state, data) {
            state.curriculaData = data;
        },
        setCurriculumData(state, data) {
            state.curriculum = data;
        },
        setNewCurriculumData(state, data) {
            state.newCurriculum = data;
        },
        setStatus(state, status) {
            state.status = status;
        },
        addDisciplineToCurriculum(state, discipline) {
            state.curriculum.disciplines.push(discipline);
        },
        removeDisciplineFromCurriculum(state, discipline) {
            state.curriculum.disciplines = state.curriculum.disciplines.filter(d => d.id !== discipline.id);
        },
    },
    actions: {
        async getCurricula({ commit, dispatch }, payload) {
            try {
                const response = await CurriculaService.getCurricula(payload.data, payload.userToken);
                commit('setCurriculaData', response);
            } catch (error) {
                console.error('Erro ao buscar currículos', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao buscar currículos'));
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },
        async createCurriculum({ commit, dispatch }, payload) {
            try {
                const response = await CurriculaService.createCurriculum(payload.curriculum, payload.userToken);
                commit('setNewCurriculumData', response);
                commit('setStatus', 'Currículo adicionado com sucesso');
                this.dispatch('toastfy/activeSuccesNotification', { text: "Matriz curricular adicionada com sucesso" });
            } catch (error) {
                notifyStoreError(dispatch, 'Erro ao adicionar matriz curricular', error);
                commit('setStatus', 'Erro ao adicionar matriz curricular');
            }
        },
        async getCurriculum({ commit }, payload) {
            try {
                const response = await CurriculaService.getCurriculumById(payload.data, payload.userToken);
                commit('setCurriculumData', response.data);
            } catch (error) {
                console.error('Erro ao buscar currículo', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao buscar currículo'));
            }
        },
        async updateCurriculum({ commit, dispatch }, payload) {
            try {
                const response = await CurriculaService.updateCurriculum(payload.data, payload.userToken);
                commit('setCurriculumData', response.data);
                commit('setStatus', 'Matriz curricular atualizada com sucesso');
                this.dispatch('toastfy/activeSuccesNotification', { text: "Matriz curricular atualizada com sucesso" });
            } catch (error) {
                notifyStoreError(dispatch, 'Erro ao atualizar matriz curricular', error);
                commit('setStatus', 'Erro ao atualizar matriz curricular');
            }
        },
        async deleteCurriculum({ commit, dispatch }, payload) {
            try {
                await CurriculaService.deleteCurriculum(payload.data, payload.userToken);
                commit('setStatus', 'Matriz curricular deletada com sucesso');
                this.dispatch('toastfy/activeSuccesNotification', { text: "Matriz curricular deletada com sucesso" });
            } catch (error) {
                notifyStoreError(dispatch, 'Erro ao deletar matriz curricular', error);
                commit('setStatus', 'Erro ao deletar matriz curricular');
            }
        },

        async attachDisciplines({ commit }, payload) {
            try {
                await CurriculaService.attachDisciplines(payload.curriculumId, payload.disciplineIds, payload.userToken);
                commit('setStatus', 'Disciplinas vinculadas com sucesso');
                // Refresh the list or specific curriculum
            } catch (error) {
                console.error('Erro ao vincular disciplinas', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao vincular disciplinas'));
                throw error;
            }
        },

        async detachDiscipline({ commit }, payload) {
            try {
                await CurriculaService.detachDiscipline(payload.curriculumId, payload.disciplineId, payload.userToken);
                commit('setStatus', 'Disciplina desvinculada com sucesso');
            } catch (error) {
                console.error('Erro ao desvincular disciplina', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao desvincular disciplina'));
                throw error;
            }
        },
        async changeDisciplineOrder({ commit }, payload) {
            try {
                await CurriculaService.changeDisciplineOrder(payload.curriculumId, payload.disciplineId, payload.order, payload.userToken);
                commit('setStatus', 'Ordem da disciplina alterada com sucesso');
            } catch (error) {
                console.error('Erro ao alterar ordem da disciplina', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao alterar ordem da disciplina'));
                throw error;
            }
        }
    }
}
